import { USER_MANAGEMENT_BASE_URL } from '../consts';
import { usePaginatedGet, UsePaginatedGetParams, UsePaginatedGetReturnType } from '../../../../api';

export type LocalAccountsHostnamesFilters = {
    search?: string;
};

interface Params {
    filters: LocalAccountsHostnamesFilters;
}

type ReturnType = Omit<UsePaginatedGetReturnType<unknown>, 'data'> & {
    hostnames?: string[];
};

const NUMBER_OF_LOCAL_ACCOUNTS_HOSTNAMES_TO_FETCH = 100;

const convertFiltersToQueryParams = (filters: LocalAccountsHostnamesFilters): UsePaginatedGetParams['queryParams'] => {
    const queryParams: UsePaginatedGetParams['queryParams'] = {};

    Object.entries(filters).forEach(([key, value]) => {
        if (Array.isArray(value)) {
            if (value.length > 0) {
                queryParams[key] = value.toString();
            }
            return;
        }
        if (value !== undefined && value !== '') {
            queryParams[key] = value.toString();
        }
    });

    return queryParams;
};

export const useGetLocalAccountsHostnames = ({ filters }: Params): ReturnType => {
    const { data: hostnames, ...restValues } = usePaginatedGet<string>({
        url: `${USER_MANAGEMENT_BASE_URL}/localAccounts/hostnames`,
        limit: NUMBER_OF_LOCAL_ACCOUNTS_HOSTNAMES_TO_FETCH,
        queryParams: convertFiltersToQueryParams(filters)
    });

    return {
        ...restValues,
        hostnames
    };
};
